import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import 'babel-polyfill';
import Element, { MessageBox } from 'element-ui';
import './assets/css/element-variables.sass';
import filters from './filters/filters.js'; // 过滤器管理
import { get, post, getDelete, postDelete, postPut, download } from './util/http.js'; // ajax请求封装
import dict from './components/Dict/index';
import Base64 from './util/base64';
import { optionalChaining } from './util';
import Print from 'vue-print-nb';

if (Object.hasOwnProperty.call(window, 'ActiveXObject')) {
  MessageBox.confirm('由于IE兼容性问题，请使用谷歌、QQ(非兼容模式)、火狐等主流浏览器访问', '提示', {
    type: 'info',
    showCancelButton: false
  }).then();
}

// Vue配置
Vue.config.productionTip = false;
Vue.use(Print);
Vue.use(Element);
Vue.use(dict);
Vue.prototype.$Base64 = Base64;
Vue.prototype.$http = axios;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$$ = optionalChaining;
Vue.prototype.$getDelete = getDelete;
Vue.prototype.$postDelete = postDelete;
Vue.prototype.$postPut = postPut;
Vue.prototype.$download = download;

// axios配置
axios.defaults.withCredentials = true; // 开启接收header中的cookie

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

// 过滤器注册
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

// 登录验证，页面需要登录而没有登录的情况直接跳转登录
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (window.sessionStorage.user) {
      next();
    } else {
      // 未登录默认跳转首页
      window.location.href = '';
    }
  } else {
    next();
  }
});

// 处理刷新的时候vuex被清空但是用户已经登录的情况
if (window.sessionStorage.user) {
  store.dispatch('login', JSON.parse(window.sessionStorage.user));
}
if (window.sessionStorage.address) {
  store.dispatch('setCity', JSON.parse(window.sessionStorage.address));
}

// http请求request操作，每次请求注入token
axios.interceptors.request.use((config) => {
  if (store.state.user.token) {
    config.headers.Authorization = 'Bearer ' + store.state.user.token;
  }
  return config;
});

// http请求response操作，在接口响应后统一处理，相当于jQuery.$ajax的complete回调
axios.interceptors.response.use((res) => {
  if (res.status >= 200 && res.status < 300) {
    return res;
  } else {
    Vue.prototype.$message({
      message: '接口请求拦截器异常',
      type: 'error'
    });
  }
}, function (error) {
  console.log(error);
  if (error.response.data.status === 401 || error.response.status === 401) {
    const msg = store.state.user.token ? '登录失效，请重新登录' : '请先登录';
    if (!window.sessionStorage.user) {
      delete window.sessionStorage.user; // 删除本地登录用户信息
      store.dispatch('logout');
      console.log(msg);
    }
  } else {
    if (error.response.data.message) {
      Vue.prototype.$message({
        message: error.response.data.message,
        type: 'error'
      });
    } else {
      const data = error.response.data;
      console.log(data);
      if (data) {
        const fileReader = new FileReader();
        fileReader.readAsText(data);
        fileReader.onload = function () {
          const jsonData = JSON.parse(this.result); // 说明是普通对象数据，后台转换失败
          Vue.prototype.$message({
            message: jsonData.message,
            type: 'error'
          });
        };
      } else {
        Vue.prototype.$message({
          message: '操作失败',
          type: 'error'
        });
      }
    }
  }
  return Promise.reject(error);
});

function IsPC() {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
  }
  return flag;
}

if (!IsPC()) {
  window.location.href = 'https://talentsh5.baiyunholding.com';
}
